import * as angular from "angular";
import {IController} from "angular";
import {AgentInventoryTransactionModel} from "../../angular/models/agent-inventory-transaction.model";

export class AgentInventoryTransactionsTableRowComponent implements IController {

  transaction: AgentInventoryTransactionModel;

  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
  }

}

angular
  .module('bringoz.admin.agent-inventory')
  .component('agentInventoryTransactionsTableRow', {
    bindings: {
      transaction: '<'
    },
    template: require('./agent-inventory-transactions-table-row.html').default,
    controller: AgentInventoryTransactionsTableRowComponent
  });

